<script setup lang="ts">
import { computed } from 'vue';
import { getDesignerMasks, type DesignerOverlayContext } from './maskTypes';

const props = defineProps<{
  context: DesignerOverlayContext;
}>();

const masks = computed(() => getDesignerMasks(props.context.config)[props.context.viewName] || []);
</script>

<template>
  <div class="vptw:absolute vptw:inset-0 vptw:pointer-events-none">
    <img
      v-for="(mask, index) in masks"
      :key="index + '-' + mask.url"
      :src="mask.url"
      alt=""
      draggable="false"
      class="vptw:absolute vptw:max-w-none vptw:select-none vptw:pointer-events-none"
      :style="{
        top: mask.top + '%',
        left: mask.left + '%',
        width: mask.width + '%',
        height: mask.height + '%',
        zIndex: Number(mask.z ?? 10000 + index),
      }"
      loading="lazy"
    />
  </div>
</template>
